/**
 * Remove excess whitespace from the beginning and end of the string
 *
 * @returns {string}
 */
String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, "");
};

/**
 * Convert a string into a URL-friendly link representation
 *
 * @returns {string}
 */
String.prototype.linkify = function() {
    return this.trim()
        .replace(XRegExp('[^\\p{L}0-9 ]*', 'g'), '')
        .replace(/ /g, '-')
        .replace(/--+/g, '-');
};
